import { defineMessages } from "react-intl";

export const sectionMessages = defineMessages({
  configurationDescription: {
    id: "g8SYlI",
    defaultMessage: "Traffic on the store's API by kind of caller, app and API key",
    description: "configuration page, api usage entry description",
  },
  loadFailed: {
    id: "XkGv1m",
    defaultMessage: "API usage could not be loaded. Reload the page to try again.",
    description: "api usage, read failed",
  },
  freshness: {
    id: "GnlKmA",
    defaultMessage:
      "UTC days, today included. Today is partial: the totals are rebuilt every hour, at 7 minutes past.",
    description: "api usage, note on the range and how fresh the totals are",
  },
  empty: {
    id: "0K9wm0",
    defaultMessage: "No requests in this range.",
    description: "api usage, nothing in the range",
  },
});

export const rangeMessages = defineMessages({
  days: {
    id: "gq8QOy",
    defaultMessage: "Last {days} days",
    description: "api usage, range button",
  },
});

export const callerMessages = defineMessages({
  ANONYMOUS: {
    id: "XXY/fv",
    defaultMessage: "Not signed in",
    description: "api usage caller class: anonymous, including storefront server calls",
  },
  CUSTOMER: {
    id: "RHaKUu",
    defaultMessage: "Customers",
    description: "api usage caller class",
  },
  STAFF: {
    id: "tXVYPu",
    defaultMessage: "Staff",
    description: "api usage caller class",
  },
  APP: {
    id: "D521bl",
    defaultMessage: "Apps and API keys",
    description: "api usage caller class: the apps we run and every API key",
  },
});

export const columnMessages = defineMessages({
  summary: {
    id: "AuuDRY",
    defaultMessage: "Summary",
    description: "api usage, card title",
  },
  byCaller: {
    id: "r4weMg",
    defaultMessage: "By caller",
    description: "api usage, card title",
  },
  byApp: {
    id: "lFxU9p",
    defaultMessage: "Apps and API keys",
    description: "api usage, card title",
  },
  byAppDescription: {
    id: "XRmmgq",
    defaultMessage: "the apps we run and each API key, most requests first.",
    description: "api usage, apps card description",
  },
  caller: {
    id: "bl1S/+",
    defaultMessage: "Caller",
    description: "api usage, column",
  },
  name: {
    id: "BtT3Yi",
    defaultMessage: "Name",
    description: "api usage, column",
  },
  requests: {
    id: "qKQoDt",
    defaultMessage: "Requests",
    description: "api usage, column and total",
  },
  share: {
    id: "zFfUU1",
    defaultMessage: "Share",
    description: "api usage, column: share of all requests",
  },
  errors: {
    id: "NEiiW4",
    defaultMessage: "Errors",
    description: "api usage, column and total: client plus server errors",
  },
  throttled: {
    id: "fNCs7U",
    defaultMessage: "Throttled",
    description: "api usage, total: answered 429",
  },
  cost: {
    id: "jkUGGT",
    defaultMessage: "Query cost",
    description: "api usage, column and total",
  },
  writes: {
    id: "M/iFEF",
    defaultMessage: "Writes",
    description: "api usage, column and total: top-level mutation fields executed",
  },
  latency: {
    id: "1/bKp0",
    defaultMessage: "Mean latency",
    description: "api usage, column and total",
  },
  lastSeen: {
    id: "Lh/L67",
    defaultMessage: "Last day seen",
    description: "api usage, column: last UTC day an app made a request",
  },
  unknownApp: {
    id: "nXgbPW",
    defaultMessage: "App #{number}",
    description: "api usage, an app the viewer may not see the name of",
  },
  apiKey: {
    id: "TieoVk",
    defaultMessage: "API key",
    description: "api usage, marks an apps-table row that is an API key",
  },
  noApps: {
    id: "IgxbXQ",
    defaultMessage: "No app or API key made a request in this range.",
    description: "api usage, apps table empty",
  },
});
